<template>
  <g v-on:click="selectSeat($event)"
     v-on:touchstart="showInfo($event, model.seat, row.row, model.id, row.id)"
     v-on:mouseenter="showInfo($event, model.seat, row.row, model.id, row.id)"
     v-on:mouseleave="hideInfo"
     :class="['seat', `s-${model.seat.status}`, `c${seatInfo.category}`, `scan-${model.seat.scanned}`]"
     :disabled="isSeatDisabled">
    <circle :cx="getSeatSVG(row.id, model.id).x" :cy="getSeatSVG(row.id, model.id).y" :r="getRadius"></circle>
    <text v-if="$store.state.isAdmin" transform="translate(0, 0.25)" text-anchor="middle" alignment-baseline="middle" :x="getSeatSVG(row.id, model.id).x" :y="getSeatSVG(row.id, model.id).y">{{ model.id }}</text>
  </g>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  props: ['model', 'row'],
  name: 'Seat',
  data() {
    return {
      timer: null,
      disabledStatusList: ['online_sold', 'offline_sold', 'reservation', 'locked', 'subscription'],
      lozeRows: ['k-l', 'k-r', 'm-l', 'm-r'],
    }
  },

  computed: {
    isSeatDisabled() {
      let disabled = false;
      if (!this.$store.state.isAdmin) {
        disabled = this.model.seat.status != 'available' && this.model.seat.status != 'selected'
      }
      return disabled;
    },

    getRadius() {
      if (this.$store.state.isAdmin) return 4.5
      return 4
    },

    seatInfo() {
      return this.$store.getters.getSeatInfo(this.model.seat, this.row.row, this.model.id, this.row.id);
    },

    ...mapGetters([
      'getSeatSVG',
    ])
  },

  methods: {
    async selectSeat(e) {
      if (e.target.parentNode.getAttribute('disabled') != 'disabled' && !this.disabledStatusList.includes(this.model.seat.status)) {
        if (!this.$store.state.isAdmin) this.$store.dispatch('toggleSeatState', [this.row.id, this.model.id]);
        else if (this.$store.state.isAdmin) this.$store.dispatch('toggleSeatState', [this.row.id, this.model.id]);
      }

      if (this.$store.state.dialogs.updateSubscription && !this.disabledStatusList.includes(this.model.seat.status)) {
        this.$store.state.pageLoaded = false;
        let context = {
          'season': this.$store.state.activeSeasonID,
          'subscription': this.$store.state.selectedObject.id,
          'seat_updates': {
            'status': this.model.seat.status,
            'seats': [this.row.id + '-' + this.model.id],
          },
          'state_time': this.$store.state.theatre.state_time
        }

        await this.$store.dispatch('updateSubscription', {context});
        this.$store.state.pageLoaded = true;
      }

      if (this.$store.state.dialogs.editTicketTheatre && !this.disabledStatusList.includes(this.model.seat.status)) {
        this.$store.state.pageLoaded = false;
        this.$store.state.selectedObject.rows = this.$store.state.theatre.rows;
        await this.$store.dispatch('manipulateData', {
          type: 'updateSelectedData',
          stateObject: 'performances',
          selectedObject: 'selectedObject'
        })
        this.$store.state.pageLoaded = true;
      }

      if (!['selected', 'available', 'unavailable', 'locked', 'subscription'].includes(this.model.seat.status) && this.$route.params.type !== 'uredi') {
        this.$store.state.loading = true;
        await this.$store.dispatch('getTransactionData', `${this.row.id}-${this.model.id}`);
        this.$store.state.currentTransaction = JSON.parse(JSON.stringify(this.$store.state.currentTransaction[0]));
        this.$store.state.dialogs.transactionDetails = true;
        this.$store.state.loading = false;
      }
    },

    showInfo(e, seat, row, seatID, rowID) {
      if (!this.$store.state.isAdmin) {
        let rowName = this.row.id.split('-');
        rowName = `${rowName[0]}-${rowName[1]}`
        this.timer = setTimeout(() => {
          this.$store.state.hoverBoxPosition = {x: e.clientX, y: e.clientY};
          this.$store.state.seatInfoVisiblity = 'is-visible';
          this.$store.state.hoveredSeat = this.$store.getters.getSeatInfo(seat, row, seatID, rowID);
          if ((this.lozeRows.includes(rowName) && (seatID == 1 || seatID == 2))) this.$store.state.hoveredSeat.isBox = true;
        }, 200)
      }
    },

    hideInfo() {
      this.$store.state.seatInfoVisiblity = 'is-hidden';
      clearInterval(this.timer)
    },

    getSeatOrientation(rowID) {
      return rowID.split('-')[1]
    },
  }
}
</script>

<style lang="scss">
.seat{
	cursor: pointer;
	.circle{
		transition: fill 200ms;
	}

	text{
		font-size: 5px;
    fill: #fff;
	}

  &[disabled="disabled"]{
		circle{
			fill: #e9e9e9;
		}
	}

  &:not([disabled="disabled"]){
    &.s-available{
      circle{
        fill: #34a853;
      }

      text{
        fill: #fff;
      }
    }

    &.s-unavailable{
      circle{
        fill: #ffdab9;
      }

      text{
        fill: #000;
      }
    }

    &.s-system_reserve{
      circle{
        fill: #333;
      }
    }

    &.s-online_sold{
      circle{
        fill: #ff5252;
      }
    }

    &.s-used_in_performance{
      circle{
        fill: #5532ff;
      }

      text{
        fill: #fff;
      }
    }

    &.s-online_checkout{
      circle{
        fill: #e9e9e9;
      }
    }

    &.s-offline_sold{
      circle{
        fill: #970a0a;
      }

      text{
        fill: #fff;
      }
    }

    &.s-reservation{
      circle{
        fill: #005bf5;
        //fill: #09789e;
      }
    }

    &.s-lease{
      circle{
        fill: #8844ff;
      }
    }

    &.s-sponsor{
      circle{
        fill: #efa135;
      }
    }

    &.s-selected{
      circle{
        fill: #e9e9e9;
        stroke: #111;
      }

      text{
        fill: #000;
      }
    }

    &.s-theatre_manager{
      circle{
        fill: #a77b6b;
      }
    }

    &.s-partner_checkout{
      circle{
        fill: #859812;
      }
    }

    &.s-partner_sold{
      circle{
        fill: #6ddeec;
      }
    }


    &.s-offline_checkout{
      circle{
        fill: #e9e9e9;
      }
    }

    &.s-subscription{
      circle{
        fill: #123456;
      }
    }

    &.s-locked{
      circle{
        fill: #654321;
      }
    }
    &.s-zamjena_web {
      circle {
        fill: #f7ff6f;
      }
      text {
        fill: #000000;
      }
    }

    &.s-zamjena_pretplata {
      circle {
        fill: #7d7d7d;
      }
    }
    &.s-zamjena_rezervirano {
      circle {
        fill: #ff0080;
      }
    }

    &.s-in_guests {
      circle {
        fill: #be7713;
      }
    }

    &.s-protocol {
      circle {
        fill: #9c3997;
      }
    }

    &.s-premiere {
      circle {
        fill: #9e4a19;
      }
    }

    &.s-najam {
      circle {
        fill: #ee66c5;
      }
    }

    &.s-press {
      circle {
        fill: #7e6e44;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Theatre/Seat.vue